<template>
  <div class="row no-gutters content-loader">
    <div class="col-8">
      <div class="row places-row no-gutters">
        <div class="col-4">
          <content-loader
            :width="100"
            :height="100"
            :speed="1"
            primaryColor="rgba(0, 0, 0, .05)"
            secondaryColor="rgba(0, 0, 0, .15)"
          >
            <rect x="0" y="0" rx="4" ry="4" width="100" height="100" />
          </content-loader>
        </div>
        <div class="col-4">
          <content-loader
            :width="100"
            :height="100"
            :speed="1"
            primaryColor="rgba(0, 0, 0, .05)"
            secondaryColor="rgba(0, 0, 0, .15)"
          >
            <rect x="0" y="0" rx="4" ry="4" width="100" height="90" />
          </content-loader>
        </div>
        <div class="col-4">
          <content-loader
            :width="100"
            :height="100"
            :speed="1"
            primaryColor="rgba(0, 0, 0, .05)"
            secondaryColor="rgba(0, 0, 0, .15)"
          >
            <rect x="0" y="0" rx="4" ry="4" width="100" height="100" />
          </content-loader>
        </div>
      </div>
    </div>
    <div class="col-4">
      <div class="row no-gutters pr-2 pl-2">
        <div class="col-12">
          <content-loader
            :width="100"
            :height="100"
            :speed="1"
            primaryColor="rgba(0, 0, 0, .05)"
            secondaryColor="rgba(0, 0, 0, .15)"
          >
            <rect x="0" y="0" rx="4" ry="4" width="100" height="50" />
            <rect x="0" y="65" rx="4" ry="4" width="40" height="5" />
            <rect x="80" y="65" rx="4" ry="4" width="20" height="5" />
          </content-loader>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ContentLoader } from 'vue-content-loader';

export default {
  name: 'CompetitionShimming',
  components: {
    ContentLoader,
  },
};
</script>

<style lang="scss" scoped>
.content-loader {
  svg {
    margin: 20px;
  }
}
</style>